import getProjection from 'owa-popout-v2/lib/utils/getProjection';
import type AddinInstance from '../store/schema/AddinInstance';

export default function getAddinInstanceString(
    targetLocation: Window | string,
    hostItemIndex: string
): string | null {
    let tabId: string = '';
    if (typeof targetLocation == 'string') {
        tabId = targetLocation;
    } else {
        const projection = getProjection(targetLocation);
        tabId = projection ? projection.tabId : targetLocation === window ? 'Main' : null;
    }
    const addinInstance: AddinInstance = {
        hostItemIndex: hostItemIndex,
        tabId: tabId,
    };
    const addinInstanceString: string = JSON.stringify(addinInstance);
    return addinInstanceString;
}
